import { toSupervisorTeamSearch } from '@/features/supervisor/lib/teamSearch';
import type { SupervisorOverviewSearch } from '@/features/supervisor/types/supervisor';
import { SidebarMenuButton } from '@/shared/components/AppSidebar/SidebarMenuButton';
import { Trans, useLingui } from '@lingui/react/macro';
import { Link } from '@tanstack/react-router';
import { ChevronLeft } from 'lucide-react';
import type { ReactNode } from 'react';

/** Route-agnostic shell for a Supervisor team secondary rail. */
export function SupervisorTeamRailFrame({
  search,
  children,
}: {
  search: SupervisorOverviewSearch;
  children: ReactNode;
}) {
  const { t } = useLingui();

  return (
    <nav className="flex min-h-0 flex-1 flex-col" aria-label={t`Supervisor navigation`}>
      <div className="shrink-0 px-1.5 pb-1 pt-2">
        <SidebarMenuButton asChild size="sm" className="text-muted-foreground">
          <Link to="/supervisor/team" search={toSupervisorTeamSearch(search)}>
            <ChevronLeft size={14} aria-hidden />
            <span className="truncate">
              <Trans>Supervisor</Trans>
            </span>
          </Link>
        </SidebarMenuButton>
      </div>
      {children}
    </nav>
  );
}
